module.exports = __webpack_public_path__ + "img/case45.83a1c50f.png";